import { useEffect, useState } from 'react';
import format from 'date-fns/format';
import { useExtractActionService, useExtractService } from 'app/utils/services/extractService';
import logger from 'app/utils/logger';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import schema from './schema';
import { useLocation } from 'react-router-dom';
import {email, onlyNumber} from "app/constants/regex";
import {useLayoutContext} from "app/storage/LayoutContext";
import useCurrencySymbol from "app/utils/customHooks/useCurrencySymbol";

interface Props {
  accountValue?: string;
  accountsList?: any[];
}

const useExtractModal = (props: Props) => {
  const { t } = useTranslation();
  const { accountValue,accountsList } = props;
  const [account , setAccount] = useState<{ value: string; label: string }>(null);
  const [showExtractModal, setShowExtractModal] = useState(false);
  const [showEmail, setShowEmail] = useState(false);
  const [changeSwitch, setChangeSwitch] = useState(false);
  const [firstFocused, setFirstFocused] = useState(false);
  const [secondFocused, setSecondFocused] = useState(false);
  const [nextDate, setNextDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [resNextDate, setNextResDate] = useState('');
  const [resEndDate, setEndResDate] = useState('');
  const [selectedPeriod, setSelectedPeriod] = useState<{ value: string; label: string }>();
  const [selectedFile, setSelectedFile] = useState<{ value: string; label: string }>();
  const [emailInput, setEmailInput] = useState<string>();
  const [selectedAutoStatementPeriod, setSelectedAutoStatementPeriod] = useState<string>('');
  const [openEmailModal, setOpenEmailModal] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [errorMessage,setErrorMessage] = useState('');

  const location = useLocation();
  const path = location.pathname.substring(3);
  const search = location.search;

  const methods = useForm({ resolver: yupResolver(schema) });

  const [accOptions,setAccOptions] = useState([]);
  const {
    handleSubmit,
    register,
    formState: { errors, isValid },
    control,
    setValue,
    getValues,
    clearErrors,
  } = methods;

  const { dataExtract, extractMutation, isLoadingExtract } = useExtractService(`${path}${search}`);
  const { dataExtractActions, extractActionsMutation, isSuccessExtractActions, isLoadingExtractActions } =
    useExtractActionService(`${path}${search}`);

  useEffect(() => {
    if (dataExtract?.periodicity !== undefined) {
      if (Object.keys(dataExtract?.periodicity).length !== 0) {
        setShowEmail(dataExtract?.periodicity.is_regular);
        setChangeSwitch(dataExtract?.periodicity.is_regular);
        setEmailInput(dataExtract?.periodicity.email);
        setSelectedAutoStatementPeriod(dataExtract?.periodicity.periodicity);
        setValue('email', dataExtract?.periodicity.email);
        setValue('showEmail', dataExtract?.periodicity.is_regular);
        setValue('periodicity', dataExtract?.periodicity.periodicity);
      }
      const selectFile = dataExtract?.file_format_types.find(
        (elem: any) => elem.value === dataExtract?.periodicity.file_type
      );
      const periodicityType = dataExtract?.periodicy_types.find(
        (elem: any) => elem.value === dataExtract?.periodicity.type
      );

      setSelectedFile(selectFile);
      setValue('fileType', selectFile);
      setSelectedPeriod(periodicityType);
      setValue('selectPeriod', periodicityType);
      if (dataExtract?.periodicity.type === '-1') {
        const start = new Date(dataExtract?.periodicity.start_date);
        const end = new Date(dataExtract?.periodicity.end_date);
        setNextResDate(dataExtract?.periodicity.start_date);
        setNextDate(start);
        setEndResDate(dataExtract?.periodicity.end_date);
        setEndDate(end);
      }
    } else {
      setSelectedPeriod(null);
      setSelectedFile(null);
      setEmailInput('');
      setValue('email', '');
      setShowEmail(false);
      setValue('showEmail', false);
      setNextResDate('');
      setEndResDate('');
      setSelectedAutoStatementPeriod('');
      setValue('selectPeriod', {});
      setValue('startDate', '');
      setValue('endDate', '');
      setValue('periodicity', '');
    }
  }, [dataExtract]);


  useEffect(() => {


    const accountData = accountsList.map((item) => {
      return {
        value: item.iban,
        label: `${item.emp_title} (${item.iban}) - ${item.main_balance} ${useCurrencySymbol(item.currency)}`,
        balance: item.main_balance,
        blocked: item.blocked_balance,
        name: item.emp_title,
        have_tax_order: item.have_tax_order,
        currency: item.currency,
        status: item.state,
        iban: item.iban,
        goverment_amount: item.goverment_amount,
      };
    });
    setAccOptions(accountData);

    setAccount(accountData.find(option => option.value === accountValue) || accountData[0]); //neew to fix
  }, []);

  // useEffect(() => {
  //
  // }, [accOptions]);
  //
  useEffect(() => {
    if (isSuccessExtractActions && dataExtractActions?.file_url) {
      window.open(dataExtractActions?.file_url);
    }
    else if (dataExtractActions?.result === 'timeout') {
      setOpenEmailModal(true)
      setEmailInput(dataExtractActions?.default_email)
    }
  }, [dataExtractActions]);

  const onFocusNext = () => {
    setFirstFocused(true);
  };
  const onFocusEnd = () => {
    setSecondFocused(true);
  };

  const handlerBlur = () => {
    setFirstFocused(false);
    setSecondFocused(false);
  };

  const handlerNextDate = (startDate_: any) => {
    setNextDate(startDate_);
    setNextResDate(format(startDate_, 'yyyy-MM-dd'));
    handlerBlur();
  };
  const handlerEndDate = (endDate_: any) => {
    setEndDate(endDate_);
    setEndResDate(format(endDate_, 'yyyy-MM-dd'));
    handlerBlur();
  };

  const onChangePeriod = (newValue: any) => {
    setSelectedPeriod(newValue);
  };

  const onChangeAccount = (newValue: any) => {
    setAccount(newValue);
  };


  const onChangeFile = (newValue: any) => {
    setSelectedFile(newValue);
  };

  const handleChangeAutoStatementPeriod = (e: any) => {
    setSelectedAutoStatementPeriod(e.target.value);
  };

  const handlerOpenExtract = () => {
    setShowExtractModal(true);
    extractMutation({ acc_no: account.value });
  };

  const handleCheckData = (periodValue: string, bool: boolean, action: string, data: any) => {
    if (periodValue === '-1' && bool) {
      extractActionsMutation({
        data: {
          action,
          file_type: selectedFile === undefined ? '' : selectedFile.value,
          type: data.selectPeriod?.value,
          start_date: resNextDate,
          end_date: resEndDate,
          is_regular: showEmail,
          email: emailInput,
          periodicity: selectedAutoStatementPeriod,
          acc_no: account.value

        },
        url: dataExtract?.business_key,
      });
    } else if (periodValue === '-1' && !bool) {
      extractActionsMutation({
        data: {
          action,
          file_type: selectedFile === undefined ? '' : selectedFile.value,
          type: data.selectPeriod?.value,
          start_date: resNextDate,
          end_date: resEndDate,
          is_regular: showEmail,
          acc_no: account.value

        },
        url: dataExtract?.business_key,
      });
    } else if (periodValue !== '-1' && bool) {
      extractActionsMutation({
        data: {
          action,
          file_type: selectedFile === undefined ? '' : selectedFile.value,
          type: data.selectPeriod?.value,
          is_regular: showEmail,
          email: emailInput,
          periodicity: selectedAutoStatementPeriod,
          acc_no: account.value
        },
        url: dataExtract?.business_key,
      });
    } else {
      extractActionsMutation({
        data: {
          action,
          file_type: selectedFile === undefined ? '' : selectedFile.value,
          type: data.selectPeriod?.value,
          is_regular: showEmail,
          acc_no: account.value
        },
        url: dataExtract?.business_key,
      });
    }
  };

  getValues('periodicity');

  const handleDownload = (data: FormData) => {
    setShowExtractModal(false);
    handleCheckData(selectedPeriod === undefined ? '' : selectedPeriod.value, showEmail, 'download', data);
  };

  const handleSave = (data: any) => {

    setErrorMessage('');
    setShowExtractModal(false);
    handleCheckData(selectedPeriod.value, showEmail, 'save', data);
  };

  const handleSendToEmail = (data?: any) => {

    if(!email.test(emailInput)) {
      setErrorMessage('Daxil etdiyiniz e-mail formatı yanlışdır')
    }
    else {
      extractActionsMutation({
        data: {
          email: emailInput,
        },
        url: dataExtract?.business_key,
      });
      setOpenEmailModal(false);
      setSuccessModal(true);
    }
  }
  const handleSwitch = (checked: boolean) => {
    setShowEmail(checked);
    if (dataExtract?.periodicity.is_regular) {
      setChangeSwitch(true);
    }
  };

  const handleChangeEmail = (e: any) => {
    setEmailInput(e.target.value);
  };

  const handleClose = () => {
    setEmailInput('');
    setValue('email', '');
    setSelectedPeriod(null);
    setValue('selectPeriod', null);
    setSelectedFile(null);
    setValue('startDate', '');
    setValue('endDate', '');
    setValue('periodicity', '');
    setValue('fileType', null);
    clearErrors('selectPeriod');
    clearErrors('email');
    clearErrors('fileType');
    clearErrors('periodicity');
    clearErrors('startDate');
    clearErrors('endDate');
    setChangeSwitch(false);
  };

  return {
    t,
    showExtractModal,
    setShowExtractModal,
    showEmail,
    setShowEmail,
    setNextDate,
    setEndDate,
    nextDate,
    selectedPeriod,
    firstFocused,
    secondFocused,
    onFocusNext,
    onFocusEnd,
    handlerBlur,
    endDate,
    resNextDate,
    resEndDate,
    handlerNextDate,
    handlerEndDate,
    handleChangeEmail,
    onChangePeriod,
    emailInput,
    setEmailInput,
    isLoadingExtract,
    onChangeFile,
    selectedFile,
    dataExtract,
    handlerOpenExtract,
    handleDownload,
    handleChangeAutoStatementPeriod,
    handleSave,
    selectedAutoStatementPeriod,
    register,
    errors,
    handleSubmit,
    isValid,
    control,
    methods,
    setValue,
    handleClose,
    handleSwitch,
    changeSwitch,
    isLoadingExtractActions,
    openEmailModal,
    handleSendToEmail,
    setOpenEmailModal,
    errorMessage,
    successModal,
    setSuccessModal,
    setErrorMessage,
    onChangeAccount,
    account,
    accOptions,
  };
};

export default useExtractModal;
